<template>
  <div id="app" :class="{ en: $store.state.dynamic.lang !== 'zh' }">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  name: "App",
  data() {
    return {};
  },
  methods: {},
  mounted() {
    const lang = localStorage.getItem("tfl-lang") || "de";
    console.log(lang);
    this.$store.commit("dynamic/SET_DYNAMIC_LANG", lang);
  },
};
</script>

<style lang="less">
html {
  background-color: #000000;
}

.van-overlay {
  z-index: 1999;
}

#id {
  background-color: #000000;
}

.el-select-dropdown {
  margin: 0 !important;
  border-radius: 0 !important;
  border: none !important;

  .el-select-dropdown__wrap {
    .el-scrollbar__view {
      padding: 0 !important;
      padding-bottom: 3px !important;

      .el-select-dropdown__item {
        height: 44px;
        line-height: 44px;

        &.selected {
          background: rgba(0, 0, 0, 0.5);

          & > span {
            height: 16px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 16px;
          }
        }

        & > span {
          height: 16px;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 16px;
        }
      }
    }
  }

  & > .popper__arrow {
    display: none;
  }
}

.el-cascader__dropdown {
  & > .el-cascader-panel {
    & > .el-cascader-menu {
      width: 204px;

      .el-cascader-menu__list {
        & > li {
          height: 44px;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #000;
          line-height: 16px;

          &.in-active-path {
            background-color: rgba(0, 0, 0, 0.5);
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue